import { Route, Routes, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import AppraisalPipeline from "../components/AppraisalPipeline";
import AssignOrder from "../components/AssignOrder";
import AppraisalForm from "../components/AppraisalForm";
import ValueCheckPipeline from "../components/ValueCheckPipeline";
import AssignValueCheck from "../components/AssignValueCheck";
import ValueCheckStatus from "../components/ValueCheckStatus";
import ValueCheckForm from "../components/ValueCheckForm";
import ValueCheckResponse from "../components/ValueCheckResponse";
import LoginState from "../helpers/LoginState";
import Login from "../components/Login";
import AppraiserDashboard from "../components/AppraiserDashboard";
import OrderUpdate from "../components/OrderUpdate";
import Blank from "../helpers/Blank";
import UploadFiles from "../components/UploadFiles";
import ViewFiles from "../components/ViewFiles";
import PaymentSuccess from "../components/PaymentSuccess";
import ManageAppraisers from "../components/ManageAppraisers";
import Order from "../components/Order";
import ValueCheck from "../components/ValueCheck";
import Settings from "../components/Settings";
import OrderBid from "../components/OrderBid";
import Register from "../components/Register";
import AppraiserFiles from "../components/AppraiserFiles";
import RequestAppraisal from "../components/RequestAppraisal";
import ModifyAppraiser from "../components/ModifyAppraiser";
import OrderSubmitted from "../components/OrderSubmitted";
import { withRouter } from "../helpers/withRouter";
import React from "react";

const PageRoutes = () => {
  const navigate = useNavigate();
  const lastTS = localStorage.getItem("lastTimeStamp");

  var user = localStorage.getItem("user");
  if (user) {
    LoginState.loggedIn = JSON.parse(user).loggedIn;
    LoginState.userRole = JSON.parse(user).userRole;
  }

  if (!lastTS) {
    // no timestamp found (logout)
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("lastTimeStamp");
    LoginState.loggedIn = false;
    LoginState.displayName = "";
  } else {
    const elapsedSeconds = (Date.now() - lastTS) / 1000;
    if (elapsedSeconds > 60 * 60 * 1) {
      // 1 hour
      // time exceeded (logout)
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("lastTimeStamp");
      LoginState.loggedIn = false;
      LoginState.displayName = "";

      // for certain pages, dont redirect
      if (
        !this.props.router.location.pathname.includes("register") &&
        !this.props.router.location.pathname.includes("vc-response") &&
        !this.props.router.location.pathname.includes("order-bid") &&
        !this.props.router.location.pathname.includes("payment-success") &&
        !this.props.router.location.pathname.includes("wait")
      ) {
        navigate("/");
      }
    } else {
      // update elapsed time
      localStorage.removeItem("lastTimeStamp");
      localStorage.setItem("lastTimeStamp", Date.now());
    }
  }

  return (
    <React.Fragment>
      <Header />
      <Routes>
        {/* Routes for any login state or role */}
        <Route path="/order-bid/:id" element={<OrderBid />} />
        <Route path="/register/:id" element={<Register />} />
        <Route path="/vc-response/:id" element={<ValueCheckResponse />} />
        <Route path="/payment-success/:id" element={<PaymentSuccess />} />
        <Route path="/appraiser-files/:id" element={<AppraiserFiles />} />
        <Route path="/request/:id" element={<RequestAppraisal />} />
        <Route path="/submitted/:id" element={<OrderSubmitted />} />
        <Route path="/wait" element={<Blank />} />

        {LoginState.loggedIn && LoginState.userRole === "Admin" && (
          <React.Fragment>
            <Route path="/order/:id" element={<Order />} />
            <Route path="/value-check/:id" element={<ValueCheck />} />
            <Route path="/value-check" element={<ValueCheckPipeline />} />
            <Route path="/value-status/:id" element={<ValueCheck />} />
            <Route path="/assign-order/:id" element={<AssignOrder />} />
            <Route path="/value-check-form" element={<ValueCheckForm />} />
            <Route path="/view-files/:id" element={<ViewFiles />} />
            <Route path="/pipeline" element={<AppraisalPipeline />} />
            <Route path="/appraisal-form" element={<AppraisalForm />} />
            <Route path="/manage-users" element={<ManageAppraisers />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/order-bid/:id" element={<OrderBid />} />
            <Route path="/modify-appraiser/:id" element={<ModifyAppraiser />} />
            <Route path="/" element={<AppraisalPipeline />} />
          </React.Fragment>
        )}

        {LoginState.loggedIn && LoginState.userRole === "Appraiser" && (
          <React.Fragment>
            <Route path="/order/:id" element={<Order />} />
            <Route path="/value-check/:id" element={<AssignValueCheck />} />
            <Route path="/value-status/:id" element={<ValueCheck />} />
            <Route path="/assign-order/:id" element={<AssignOrder />} />
            <Route path="/value-check-form" element={<ValueCheckForm />} />
            <Route path="/order-update/:id" element={<OrderUpdate />} />
            <Route path="/upload-files/:id" element={<UploadFiles />} />
            <Route path="/view-files/:id" element={<ViewFiles />} />
            <Route
              path="/appraiser-dashboard"
              element={<AppraiserDashboard />}
            />
            <Route path="/settings" element={<Settings />} />
            <Route path="/" element={<AppraiserDashboard />} />
          </React.Fragment>
        )}

        {LoginState.loggedIn && LoginState.userRole === "Portal" && (
          <React.Fragment>
            <Route path="/order/:id" element={<Order />} />
            <Route path="/pipeline" element={<AppraisalPipeline />} />
            <Route path="/appraisal-form" element={<AppraisalForm />} />
            <Route path="/value-check-form" element={<ValueCheckForm />} />
            <Route path="/value-status/:id" element={<ValueCheckStatus />} />
            <Route path="/view-files/:id" element={<ViewFiles />} />
            <Route path="/" element={<AppraisalPipeline />} />
          </React.Fragment>
        )}

        {!LoginState.loggedIn && (
          <React.Fragment>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Login />} />
          </React.Fragment>
        )}
      </Routes>
    </React.Fragment>
  );
};

export default withRouter(PageRoutes);
